import * as React from 'react';

const NotificationsIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={18}>
    <path
      fill={fillColor}
      d="M.959 14.833a.603.603 0 0 1-.445-.18.61.61 0 0 1-.18-.448.61.61 0 0 1 .625-.621h1.125V7.207c0-1.139.344-2.17 1.031-3.093a4.414 4.414 0 0 1 2.719-1.74v-.604c0-.32.113-.584.339-.792.226-.208.5-.312.823-.312.322 0 .598.104.828.312.229.208.343.472.343.792v.604a4.457 4.457 0 0 1 2.73 1.74 5.024 5.024 0 0 1 1.041 3.093v6.375h1.104c.177 0 .326.06.446.181.12.12.18.27.18.448s-.06.326-.18.444a.61.61 0 0 1-.446.177H.96Zm6.042 2.5c-.445 0-.834-.163-1.167-.49a1.588 1.588 0 0 1-.5-1.176h3.333c0 .458-.163.85-.49 1.177-.326.326-.718.49-1.176.49Zm-3.667-3.75h7.354V7.208c0-1.041-.35-1.92-1.052-2.635C8.935 3.858 8.066 3.5 7.032 3.5c-1.035 0-1.91.358-2.625 1.073-.715.715-1.073 1.594-1.073 2.635v6.375Z"
    />
  </svg>
);

export default NotificationsIcon;
